import { render, staticRenderFns } from "./logarithmic-representation-switcher.vue?vue&type=template&id=5f474816&scoped=true&"
import script from "./logarithmic-representation-switcher.vue?vue&type=script&lang=js&"
export * from "./logarithmic-representation-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f474816",
  null
  
)

export default component.exports